import { Component } from "react";
import service from "../../core/service";
import { fixNumbers, numberWithCommas, toFarsiNumber } from "../../core/utils";
import { dashboardData } from '../../Redux/services/generalService';
import { toast } from "react-toastify";

interface IProps {
  dispatch?: any;
  userData?: any;
  dashboardData:any;
}
interface IState {
  openModal: boolean;
  active?: number;
  loading?: boolean;
  data?: any;
  options?: any;
  count: string;
  DashboardsList: any;
  chartData: any;
  from_date: any;
  title: any;
  to_date: any;
  number: any;
  plan_type: string;
  page: number;
  error: any;
  shareList:any;
  str: string;
  shareHolder: any;
  debounceTimeout: any;
  clickLoading: boolean;
  price: any;


}

export class dashboardController extends Component<IProps, IState> {
  state: IState = {
    clickLoading: false,
    price:null,
    debounceTimeout: null, 
    openModal: false,
    str: "",
    shareList:[],
    count: "",
    from_date: "",
    title: "",
    to_date: "",
    number: "",
    plan_type: "",
    page: 1,
    shareHolder:null,
    error: [],
    active: 1,
    DashboardsList: {},
    loading: false,
    data: {
      labels: [],
      family: "Peyda",
      datasets: [],
    },
   
    
    chartData: [],
  };

  debounceApiCall = (shareHolder: number) => {
    if (this.state.debounceTimeout) {
      clearTimeout(this.state.debounceTimeout);
    }

    const timeout = setTimeout(() => {
      this.createPreFactor(shareHolder);
    }, 500);

    this.setState({ debounceTimeout: timeout });
  };

    async create() {
      const { price, shareHolder } = this.state;
  
      try {
        this.setState({ clickLoading: true });
  
        const response = await service.Payment.create({
          stock_amount: shareHolder,
          deposit_amount: price,
        });
        if (response) {
          this.setState({ clickLoading: false });
          const redirectUrl = response?.data?.data?.url;  
  
          if (response.status === 200) {
            toast.success("درخواست شما با موفقیت انجام شد");
            window.location.href = redirectUrl;
          } else {
            toast.error(response?.data?.message);
          }
        } else {
          toast.error(" با خطا مواجه شدید ");
          this.setState({ clickLoading: false });
        }
      } catch (err: any) {
        this.setState({ clickLoading: false });
        this.setState({ error: err?.inner });
        toast.error(err?.data?.message);
      }
    }
    getList = async () => {
      this.setState({ loading: true });
      try {
        const response = await service.Dashboard.list();
        if (response) {
          const DashboardsList = response?.data?.data;
          this.setState({
            DashboardsList,
            loading: false,
            price: DashboardsList?.debit_share_settlements_price || null,
            shareHolder: DashboardsList?.debit_amount || null,
          });
          if (this.props.dispatch) {
            this.props.dispatch(dashboardData(DashboardsList));
          }
        } else {
          this.setState({ loading: false });
        }
      } catch (error) {
        
        this.setState({ loading: false });
      }
    };

  createPreFactor = async (shareHolder: number): Promise<void> => {
    this.setState({ clickLoading: true });

    let parameters = {
      stock_amount: shareHolder ? shareHolder : 0,
    };

    const params = new URLSearchParams();

    for (const [key, value] of Object.entries(parameters)) {
      if (value) {
        params.append(key, value.toString());
      }
    }

    try {
      const response = await service.Payment.GetPrice(params);
      if (response) {
        this.setState({
          price: response?.data?.data?.price,
          clickLoading: false,
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({ clickLoading: false });
    }
  };


  handleChangeShareHolder = (e: any) => {
    const value = e.target.value;
    this.setState({ shareHolder: value });

    this.debounceApiCall(value);
  };

  paginationTimeOut: string | number | NodeJS.Timeout | undefined;
  handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    this.setState({ page: value });
    clearTimeout(this.paginationTimeOut);
    this.paginationTimeOut = setTimeout(() => {
      this.getList();
    }, 800);
  };
}
export default dashboardController;
